export default __webpack_public_path__ + "hand-pointing-upward.png";